import React from 'react';
import { Route, Routes } from "react-router-dom";

import Share from "./pages/Share";
import ThankYou from "./pages/ThankYou";
import Search from "./pages/Search";
import Detail from "./pages/Detail";
import MyTrueStories from "./pages/MyTrueStories";
import Redirect from "./pages/Redirect";

import Header from './global/Header';

import useAllSearchData from './hooks/useAllSearchData';

export default function App() {
  const [loading, error, data ] = useAllSearchData();

  // don't show anything when loading at this state - less obvious
  if(loading)
    return (<div></div>)

  if(error)
    return (<div>{ error }</div>)

  const { petTypes, breeds, dietaryGoals } = data;

  return (
  <>
  <Header
    breeds={breeds}
    petTypes={petTypes}
    dietaryGoals={dietaryGoals}
  />
  <Routes>
    <Route path='/apps/truestories/story/share' element={<Share breeds={breeds} petTypes={petTypes} dietaryGoals={dietaryGoals} />} />
    <Route path='/apps/truestories/story/share/edit/:storyId' element={<Share breeds={breeds} petTypes={petTypes} dietaryGoals={dietaryGoals} />} />
    <Route path='/apps/truestories/story/thank-you' element={<ThankYou breeds={breeds} petTypes={petTypes} dietaryGoals={dietaryGoals} />} />
    <Route path='/apps/truestories/story/search' element={<Search breeds={breeds} petTypes={petTypes} dietaryGoals={dietaryGoals} />} />
    <Route path='/apps/truestories/story/:storyId' element={<Detail breeds={breeds} petTypes={petTypes} dietaryGoalsList={dietaryGoals} />} />
    <Route path='/apps/truestories/story/:storyId/:draft' element={<Detail breeds={breeds} petTypes={petTypes} dietaryGoalsList={dietaryGoals} />} />
    <Route path='/apps/truestories/my-true-stories' element={<MyTrueStories breeds={breeds} petTypes={petTypes} dietaryGoals={dietaryGoals} />} />
    <Route index element={<Redirect loc="/pages/truestories" />} />
    <Route path='*' element={<Redirect loc="/404" />} />
  </Routes>
  </>
  )
}
